import   { createContext } from 'react';

 export const SymptomDetailsContext = createContext({})






                